import FileArea from './FileArea/index';

export default FileArea;
